import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "checkbox", "dropdown"]

  connect() {
    this.modal = new bootstrap.Modal(this.modalTarget)
    this.modal.show()

    this.modalTarget.addEventListener("hidden.bs.modal", () => {
      this.element.innerHTML = ""
    })
  }

  toggleDropdown() {
    this.dropdownTarget.disabled = !this.checkboxTarget.checked
    if (!this.checkboxTarget.checked) {
      this.dropdownTarget.value = ""
    }
  }
}
